import { title } from "echarts/lib/theme/dark";
import { pwd } from "shelljs";

/**
 * 公共翻译
 **/
const cn = {
  global: {
    home: "首页",
    logout: "退出",
    language: {
      chinese: "中文",
      english: "english"
    },
    search: "搜索",
    actions: "操作",
    edit: "编辑",
    modify: "修改",
    detail: "详情",
    details: "明细",
    add: "新增",
    delete: "删除",
    cancel: "取 消",
    more: "更多",
    export: "导出",
    select: "选择",
    close: '关 闭',
    confirm: '确 定',
    generate: "生成",
    logoutConfirm: '确认要退出吗?',
    noAccess: '您尚未开通访问权限。',
    noPermission: '无权限，请联系管理员！'
  },

  datepicker: {
    recentAweek: "最近一周",
    recentAmoon: "最近一个月",
    recentThreeMonth: "最近三个月",
  },

  select: {
    select: "请选择",
    head: "请选择项目",
    grp: "请选择商户组",
    mer: "请选择营业点",
    status: "请选择状态",
    payType: "请选择支付方式",
    txnType: "请选择支付产品",
    txnId: "请选择交易类型",
    chType: "请选择支付通道",
    month: "选择月",
  },

  input: {
    input: '请输入',
    tellerNo: "请输入操作员",
    inputHeadCode: "请输入项目代码", // 请输入项目代码
    inputHeadName: "请输入项目名称", // 请输入项目名称
    inputGrpCode: "请输入商户组代码", // 请输入商户组代码
    inputGrpName: "请输入商户组名称", // 请输入商户组名称
    inputMerCode: "请输入营业点代码", // 请输入营业点代码
    inputMerName: "请输入营业点名称", // 请输入营业点名称
    headCode: "请输入项目代码",          // 项目代码
    headName: "请输入项目名称",          // 项目名称
    grpCode: "请输入商户组代码",         // 商户组代码
    grpName: "请输入商户组名称",         // 商户组名称
    merCode: "请输入营业点代码",         // 营业点代码
    merName: "请输入营业点名称",         // 营业点名称
    memo: "请输入备注",         // 请输入备注
  },

  // 状态翻译
  status: {
    normal: "正常",          // 正常
    disabled: "禁用",      // 禁用
    start: "启用",
    initial: "初始",        // 初始
    lock: "锁定",
    completed: "已完成",    // 已完成
    incomplete: "未完成",  // 未完成
    expired: "已过期",        // 已过期
    enabled: "开通",        // 开通
    closed: "关闭",          // 关闭
    yes: "是",                // 是
    no: "否",                  // 否
    success: "成功",        // 成功
    failure: "失败",         // 失败
    revoked: "已撤销",        // 已撤销
    pendingReview: "待审核",  // 待审核
    pendingExecution: "待执行",      // 待执行
    executing: "执行中",   // 执行中
    executed: "已执行",      // 已执行
    voided: "已作废",          // 已作废
    inProgress: "处理中", // 处理中
    notActivated: "未开通",
    activated: "开通",
  },

  list: {
    code: '代码',
    group: "集团",                    // 集团
    brand: "品牌",                    // 品牌
    partner: "合作伙伴",
    head: '项目',                     // 项目
    grp: "商户组",                    // 商户组
    mer: "营业点",                    //  营业点
    belGroup: "所属集团",             // 所属集团
    belBrand: "所属品牌",             // 所属品牌
    belHead: '所属项目',              // 所属项目
    belGrp: "所属商户组",             // 所属商户组
    belMer: "所属营业点",             //  所属营业点
    headCode: "项目代码",             // 项目代码
    headName: "项目名称",             // 项目名称
    grpCode: "商户组代码",            // 商户组代码
    grpName: "商户组名称",            // 商户组名称
    merCode: "营业点代码",            // 营业点代码
    merName: "营业点名称",            // 营业点名称
    status: "状态",                   // 状态
    creDate: "创建时间",              // 创建时间
    modiDate: "修改时间",             // 修改时间
    memo: "备注",                     // 备注
    summaryPeriod: "日期范围",
    to: "至",
    operatorSettings: "操作员设置",
  },

  login: {
    title: "石基星支付支付服务",
    tips: "English",
    loginBtn: "登录",
    accounts_pass_login: '账号密码登录',
    scan_code_login: '扫码快速登录',
    remember: '记住我',
    welcomeBack: '欢迎回来',
    forget_pass: '忘记密码',
    username_placeholder: "请输入用户名",
    password_placeholder: "请输入密码",
    verifyCode_placeholder: "请输入验证码",
    username_invaild: "请输入用户名",
    password_invaild: "密码长度不能小于6位",
    homepage:"返回首页",   // 返回首页
    webpageLost:"网页丢失啦！",   // 网页丢失啦！
    otherLogin: "其他登录方式",
    scancodeLogin: "扫码快速登录",
    marriott: "万豪",
    llshr: "乐高",
    daylight: "Daylight"
  },


  auth: {
    identity: {
      select: '选择身份',
      switch: '切换身份',
      invalid: '当前身份不存在，请重新登录',
      current: '当前',
      selected: '已选择当前机构~',
      logoutConfirm: '确认要退出吗?'
    },
    session: {
      timeout: '用户长时间无操作，请重新登录?',
      expired: '当前会话已过期，请重新登录',
      relogin: '重新登录',
      pwdExpired: '密码已过期，请立即修改！',
    }
  },

  system: {
    api: {
      defaultError: '系统接口{error}异常',
      connectionError: '后端接口连接异常',
      timeout: '系统接口请求超时'
    }
  },
  user: {
    profile: '个人信息',
    name: '姓名',
    account: '账号',
    type: '类型',
    admin: '管理员',
    brand: "品牌用户",
    projectAdmin: "项目-管理员",
    projectStaff: "项目-员工",
    group: "集团用户",
    logout: '退出登录',
    loginAccount: "登录账号",
    initialPassword: "初始密码",
    resetPassword: "重置密码",
    changePwd: "修改密码",
    userCode: "用户代码",
    userName: "用户姓名",
    mobile: "手机号",
    validation: {
      account: "请输入账号",
      name: "请输入用户姓名",
      charset: "仅支持输入数字、字母或'.'",
      mobile: "请输入手机号",
      lengthRule: "手机号码不能超过11位",
      formatRule: "请输入正确的手机号码",
      userExpDateNotNull: "过期日期不能为空",
    },
  },
  resetPwd: {
    title: "请输入您的邮箱",
    email: "邮箱",
    smsCode: "验证码",
    emailInput: "请输入邮箱",
    smsCodeInput: "请输入验证码",
    step1: "邮件验证",
    step2: "邮件发送成功",
    step3: "重置密码",
    step4: "完成",
    tip1: "邮件已发送",
    tip2: "请前往您的邮箱完成密码重置",
    toLogin: "去登录",
    pwdStrong: "密码强度：",
    success: "成功",
    reserPwdSuccess: "重置密码成功",
    linkInvalid: "验证链接不合法或已失效！",
    pwdValid1: "请输入密码",
    pwdValid2: "密码长度为12-20位",
    pwdValid3: "密码需包含字母和数字",
    pwd2Valid1: "请再次输入密码",
    pwd2Valid2: "两次输入密码不一致",
    pwd2Valid3: "密码长度为12-20位",
    pwd2Valid4: "密码需包含字母和数字",
    emailValid1: "请输入正确的邮箱",
    smsCodeValid1: "请输入正确的邮箱",
    applyResetPwdSuccess: "重置密码申请成功",
    title2: "请重置您的密码",
    password: "新密码",
    password2: "确认密码",
  },
  updatePwd: {
    name: "修改密码",
    userCode: "账号",
    title2: "请修改您的密码",
    oldUserPwd: "旧密码",
    newUserPwd: "新密码",
    newUserPwd2: "确认新密码",
    complete: "完成",
    pwdStrong: "密码强度：",
    success: "成功",
    pwdSuccess: "修改密码成功",
    toLogin: "去登录",
    confirm: "确认",
    pwdValid1: "请输入新密码",
    pwdValid2: "密码长度为12-20位",
    pwdValid3: "密码需包含字母和数字",
    pwdValid4: "新密码和旧密码不能相同",
    pwd2Valid1: "请再次输入新密码",
    pwd2Valid2: "两次输入密码不一致",
    pwd2Valid3: "密码长度为12-20位",
    pwd2Valid4: "密码需包含字母和数字",
  },
  email: {
    label: '邮箱',
    loginEmail: '登录邮箱',
    placeholder: '请输入邮箱',
    userCodeEmail: "登录账号，请填写自己真实的邮箱",
    validation: {
      required: '请输入邮箱',
      invalid: '请输入正确的邮箱格式',
      real: '请填写自己真实的邮箱',
    },
    actions: {
      submit: '确认提交',
      changePassword: '修改密码',
      confirmChange: '您确定修改密码吗?',
      resetConfirm: "确定要重置该用户密码?",
      warnTips: "是否确认删除此数据项?",

    },
    notifications: {
      noEmail: '暂无邮箱，请先补填邮箱，',
      sentInstructions: '确认后，将向您的邮箱发送密码修改邮件，打开邮件中的链接完成密码修改。',
      success: '操作成功。已发送重置密码邮件到操作员邮箱，请注意查收邮件，并重置密码。',
      resetSuccess: "操作成功。已发送重置密码邮件到操作员邮箱，请通知操作员查收邮件，并重置密码。",
      operatorLimit: "提示：操作员最多可新增三个",
      operatorSetup: "1. 最多可设置3名操作员",
      operatorTitle: "2. 新增完毕后，操作员邮箱将会收到激活并设置密码的邮件，激活和设置密码后，可正常使用。",
    }
  },


  // 校验规则翻译
  rule: {
    head: "请选择项目",
    grp: "请选择商户组",
    mer: "请选择营业点",
    notNullDate: "日期不能为空！",
    startNotgreaterEndTime: "起始日期不能大于结束日期！",
    exceedThirtyDays: "日期范围不能超过31天！",
    exceedOneYear: "日期范围不能超过一年！",
    exceedTwoMonths: '日期范围不能超过两个月！',
  },

  // 提示信息、报错翻译
  promptBox: {
    prompt: '提示',
    queryLoading: '正在查询...',
    querydata: "点击搜索，查询数据",
    emptyText: "暂无数据",
    errorService: "抱歉，服务器出了点问题，稍后重试～",
    NoDataOut: "暂无数据导出!",
    warn: "警告",
    deleteSuccess: "删除成功",
    editSuccess: "修改成功。",
    addSuccess: "新增成功。",
    error: '错误',
  },

};
export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn/public.js